import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  CancelInstallmentRequestType,
  CreateInstallmentRequestType,
  CreateInstallmentResponseType,
  GetInstallmentOrderPaymentDetailsRequestType,
  GetInstallmentOrderPaymentDetailsResponseType,
  GetInstallmentStatusRequestType,
  GetInstallmentStatusResponseType,
  SuccessResponseType
} from './types';

import { IbInstallmentsServicesTypes } from '.';

type NetworkCallWithAuthType = <T>(
  api: ApisauceInstance,
  url: string,
  requestObject: Record<string, unknown>,
  method: string,
  options?: Record<string, unknown>
) => Promise<T>;

class IbInstallmentsServices implements IbInstallmentsServicesTypes {
  api: ApisauceInstance;
  networkCallWithAuth: NetworkCallWithAuthType;

  constructor(networkCallWithAuth: NetworkCallWithAuthType) {
    this.api = create({
      baseURL: `${Config['INSTALLMENTS_PAYMENT_URL']}`
    });
    this.networkCallWithAuth = networkCallWithAuth;
  }

  getInstallmentOrderPaymentDetails = (
    requestObject: GetInstallmentOrderPaymentDetailsRequestType
  ): Promise<GetInstallmentOrderPaymentDetailsResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'installment_order/payments/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  createInstallment = (
    requestObject: CreateInstallmentRequestType
  ): Promise<CreateInstallmentResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'installment/create/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  getInstallmentStatus = (
    requestObject: GetInstallmentStatusRequestType
  ): Promise<GetInstallmentStatusResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'installment/status/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };

  cancelInstallment = (
    requestObject: CancelInstallmentRequestType
  ): Promise<SuccessResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'installment/cancel/v1/',
      requestObject as Record<string, unknown>,
      apiMethods.post
    );
  };
}

export { IbInstallmentsServices };
